import type DescriptionListItem from '@/components/ui/lists/descriptionList/DescriptionListItem';

import styles from './DescriptionList.module.scss';

type IDescriptionListItem = React.ReactElement<
  React.ComponentProps<typeof DescriptionListItem>,
  typeof DescriptionListItem
>;

interface Props {
  children?: IDescriptionListItem | IDescriptionListItem[] | React.ReactNode;
}

const DescriptionList: React.FC<Props> = ({ children }) => (
  <ul className={styles.descriptionList}>{children}</ul>
);

export default DescriptionList;
